<div class="st-page">
  <a class="st-back-link" (click)="goBack()"><i class="ri-arrow-left-line"></i> {{ 'backToClass' | translate }}</a>

  <div class="st-empty-state" *ngIf="loading">
    <i class="ri-loader-4-line ri-spin"></i> {{ 'loadingStudent' | translate }}
  </div>

  <div class="st-empty-state" *ngIf="!loading && loadError">
    <i class="ri-error-warning-line"></i> {{ 'couldntLoadThisStudentPleaseTryAgain' | translate }}
  </div>

  <ng-container *ngIf="!loading && !loadError && profile">
    <div class="ssd-profile-head st-card">
      <div class="st-avatar ssd-avatar-lg">
        <img *ngIf="profile.studentImage" [src]="profile.studentImage" alt="" />
        <ng-container *ngIf="!profile.studentImage">{{ studentInitials }}</ng-container>
      </div>
      <div class="ssd-profile-info">
        <h1 class="st-title">{{ profile.studentName }}</h1>
        <p class="st-subtitle">{{ classLabel }} &middot; {{ 'registrationNo' | translate }}: {{ profile.registrationId }}</p>
        <p class="st-subtitle">{{ profile.schoolName }}</p>
      </div>
      <span class="st-chip" *ngIf="attendanceInfo" [ngClass]="todayAttendanceChipClass()">{{ attendanceInfo.TodayAttendance }}</span>
    </div>

    <div class="st-stat-row" *ngIf="attendanceInfo">
      <div class="st-stat-card">
        <div class="st-stat-icon blue"><i class="ri-calendar-line"></i></div>
        <div><div class="st-stat-value">{{ monthlyAttendancePercent() }}%</div><div class="st-stat-label">{{ 'monthlyAttendance' | translate }}</div></div>
      </div>
      <div class="st-stat-card">
        <div class="st-stat-icon green"><i class="ri-line-chart-line"></i></div>
        <div><div class="st-stat-value">{{ academicAttendancePercent() }}%</div><div class="st-stat-label">{{ 'overallAttendance' | translate }}</div></div>
      </div>
    </div>

    <div class="st-tabs">
      <div class="st-tab" *ngFor="let t of tabs" [class.active]="activeTab === t.key" (click)="setTab(t.key)">
        <i [ngClass]="t.icon"></i> {{ t.label | translate }}
      </div>
    </div>

    <!-- Personal Info -->
    <div *ngIf="activeTab === 'info'">
      <div class="st-card">
        <h3 class="st-card-title">{{ 'personalInfo' | translate }}</h3>
        <div class="st-info-grid">
          <div class="st-info-item"><span class="st-info-label">{{ 'dateOfBirth' | translate }}</span><span class="st-info-value">{{ formatDate(profile.dateOfBirth) }}</span></div>
          <div class="st-info-item"><span class="st-info-label">{{ 'rollNo' | translate }}.</span><span class="st-info-value">{{ profile.rollNumber }}</span></div>
          <div class="st-info-item"><span class="st-info-label">{{ 'dateOfAdmission' | translate }}</span><span class="st-info-value">{{ formatDate(profile.dateOfAdmission) }}</span></div>
          <div class="st-info-item"><span class="st-info-label">{{ 'gender' | translate }}</span><span class="st-info-value">{{ profile.gender }}</span></div>
        </div>
      </div>

      <div class="st-card">
        <h3 class="st-card-title">{{ 'parentInfo' | translate }}</h3>
        <div class="st-info-grid">
          <div class="st-info-item"><span class="st-info-label">{{ 'fathersName' | translate }}</span><span class="st-info-value">{{ profile.parentName }}</span></div>
          <div class="st-info-item"><span class="st-info-label">{{ 'mobileNumber' | translate }}</span><span class="st-info-value"><a [href]="'tel:' + profile.mobileNumber">{{ profile.mobileNumber }}</a></span></div>
          <div class="st-info-item"><span class="st-info-label">{{ 'email' | translate }}</span><span class="st-info-value">
            <a *ngIf="profile.parentEmail" [href]="'mailto:' + profile.parentEmail">{{ profile.parentEmail }}</a>
            <ng-container *ngIf="!profile.parentEmail">{{ 'notAvailableGeneric' | translate }}</ng-container>
          </span></div>
        </div>
      </div>

      <div class="st-card">
        <h3 class="st-card-title">{{ 'address' | translate }}</h3>
        <p class="st-info-value"><i class="ri-map-pin-line"></i> {{ profile.address }}</p>
      </div>

      <div class="st-card" *ngIf="siblings.length">
        <h3 class="st-card-title">{{ 'siblings' | translate }}</h3>
        <div class="st-list-row" *ngFor="let s of siblings" (click)="openSibling(s)">
          <div class="st-avatar">
            <img *ngIf="s.studentImage" [src]="s.studentImage" alt="" />
          </div>
          <div class="st-list-text">
            <div class="st-list-title">{{ s.studentName }}</div>
            <div class="st-list-sub">{{ s.classNumber }} - {{ s.classDivision }}</div>
          </div>
        </div>
      </div>

      <div class="st-card" *ngIf="classTeachers.length">
        <h3 class="st-card-title">{{ 'classTeachersTitle' | translate }}</h3>
        <div class="st-list-row" *ngFor="let t of classTeachers">
          <div class="st-list-text">
            <div class="st-list-title">{{ t.staffName }}</div>
            <div class="st-list-sub">{{ t.designation }}</div>
          </div>
        </div>
      </div>

      <div class="st-card" *ngIf="subjectTeachers.length">
        <h3 class="st-card-title">{{ 'subjectTeachers' | translate }}</h3>
        <div class="st-list-row" *ngFor="let t of subjectTeachers">
          <div class="st-list-text">
            <div class="st-list-title">{{ t.staffName }}</div>
            <div class="st-list-sub">{{ t.subject }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fees -->
    <div *ngIf="activeTab === 'fees'">
      <div class="st-empty-state" *ngIf="feesLoading">
        <i class="ri-loader-4-line ri-spin"></i> {{ 'loadingFees' | translate }}
      </div>

      <div class="st-empty-state" *ngIf="!feesLoading && feesLoadError">
        <i class="ri-error-warning-line"></i> {{ 'couldntLoadFeeDetailsPleaseTryAgain' | translate }}
      </div>

      <div class="st-empty-state" *ngIf="!feesLoading && !feesLoadError && feesLoaded && !isFeesDataVisible">
        <i class="ri-money-dollar-circle-line"></i> {{ 'noFeesData' | translate }}
      </div>

      <ng-container *ngIf="!feesLoading && !feesLoadError && isFeesDataVisible">
        <div class="st-card">
          <div class="st-stat-row">
            <div class="st-stat-card">
              <div class="st-stat-icon blue"><i class="ri-money-dollar-circle-line"></i></div>
              <div><div class="st-stat-value">{{ formatCurrency(feesTotalAmount) }}</div><div class="st-stat-label">{{ 'totalAmount' | translate }}</div></div>
            </div>
            <div class="st-stat-card">
              <div class="st-stat-icon green"><i class="ri-check-line"></i></div>
              <div><div class="st-stat-value">{{ formatCurrency(feesTotalPaid) }}</div><div class="st-stat-label">{{ 'totalPaid' | translate }}</div></div>
            </div>
            <div class="st-stat-card" *ngIf="feesTotalDiscount > 0">
              <div class="st-stat-icon yellow"><i class="ri-price-tag-3-line"></i></div>
              <div><div class="st-stat-value">{{ formatCurrency(feesTotalDiscount) }}</div><div class="st-stat-label">{{ 'discountLabel' | translate }}</div></div>
            </div>
          </div>
          <div class="ssd-fee-progress-track">
            <div class="ssd-fee-progress-fill" [style.width.%]="feesPaidPercent()"></div>
          </div>
          <div class="st-list-sub" style="margin-top:6px;">{{ feesPaidPercent() }}% {{ 'paid' | translate }}</div>
        </div>

        <div class="st-card ssd-fee-item" *ngFor="let fee of feeItems">
          <div class="ssd-fee-item-top">
            <div class="st-list-text">
              <div class="st-list-title">{{ getFeeName(fee) }}</div>
              <div class="st-list-sub">{{ 'due' | translate }} {{ formatDate(getDueDate(fee)) }}</div>
            </div>
            <span class="st-chip" [ngClass]="statusChipClass(getStatus(fee))">{{ getStatus(fee) }}</span>
          </div>
          <div class="ssd-fee-item-grid">
            <div><span class="st-info-label">{{ getFeeTypeLabel(fee) }}</span><span class="st-info-value">{{ formatCurrency(getTotalFees(fee)) }}</span></div>
            <div><span class="st-info-label">{{ 'paid' | translate }}</span><span class="st-info-value ssd-fee-green">{{ formatCurrency(fee.Paid) }}</span></div>
            <div><span class="st-info-label">{{ 'lateFee' | translate }}</span><span class="st-info-value" [class.ssd-fee-red]="getLateFee(fee) > 0 && fee.Balance > 0">{{ formatCurrency(getLateFee(fee)) }}</span></div>
            <div><span class="st-info-label">{{ 'pending' | translate }}</span><span class="st-info-value" [class.ssd-fee-red]="fee.Balance > 0">{{ formatCurrency(fee.Balance) }}</span></div>
          </div>
          <div class="ssd-fee-discount" *ngIf="getDiscount(fee) > 0">{{ 'discountLabel' | translate }}: {{ formatCurrency(getDiscount(fee)) }}</div>
        </div>

        <ng-container *ngIf="otherFeeItems.length">
          <h3 class="st-card-title">{{ 'otherFees' | translate }}</h3>
          <div class="st-card ssd-fee-item" *ngFor="let fee of otherFeeItems">
            <div class="ssd-fee-item-top">
              <div class="st-list-text">
                <div class="st-list-title">{{ getFeeName(fee) }}</div>
                <div class="st-list-sub">{{ 'due' | translate }} {{ formatDate(getDueDate(fee)) }}</div>
              </div>
              <span class="st-chip" [ngClass]="statusChipClass(getStatus(fee))">{{ getStatus(fee) }}</span>
            </div>
            <div class="ssd-fee-item-grid">
              <div><span class="st-info-label">{{ getFeeTypeLabel(fee) }}</span><span class="st-info-value">{{ formatCurrency(getTotalFees(fee)) }}</span></div>
              <div><span class="st-info-label">{{ 'paid' | translate }}</span><span class="st-info-value ssd-fee-green">{{ formatCurrency(fee.Paid) }}</span></div>
              <div><span class="st-info-label">{{ 'lateFee' | translate }}</span><span class="st-info-value" [class.ssd-fee-red]="getLateFee(fee) > 0 && fee.Balance > 0">{{ formatCurrency(getLateFee(fee)) }}</span></div>
              <div><span class="st-info-label">{{ 'pending' | translate }}</span><span class="st-info-value" [class.ssd-fee-red]="fee.Balance > 0">{{ formatCurrency(fee.Balance) }}</span></div>
            </div>
            <div class="ssd-fee-discount" *ngIf="getDiscount(fee) > 0">{{ 'discountLabel' | translate }}: {{ formatCurrency(getDiscount(fee)) }}</div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <!-- Attendance -->
    <div *ngIf="activeTab === 'attendance'">
      <div class="st-card ssd-cal-card">
        <div class="ssd-cal-head">
          <button class="ssd-cal-nav-btn" (click)="changeCalendarMonth(-1)"><i class="ri-arrow-left-s-line"></i></button>
          <div class="ssd-cal-head-text">
            <div class="st-list-title">{{ selectedDay ? (selectedDay.date | date:'d MMM yyyy') : calendarMonthLabel }}</div>
            <div class="st-list-sub">{{ 'overall' | translate }} {{ attendanceMonthPercent }}%</div>
          </div>
          <button class="ssd-cal-nav-btn" (click)="changeCalendarMonth(1)"><i class="ri-arrow-right-s-line"></i></button>
        </div>
        <div class="ssd-cal-progress-track">
          <div class="ssd-cal-progress-fill" [style.width.%]="attendanceMonthPercent"></div>
        </div>

        <div class="ssd-cal-body" [class.ssd-cal-body-loading]="attendanceCalendarLoading">
          <div class="ssd-cal-loading-overlay" *ngIf="attendanceCalendarLoading">
            <i class="ri-loader-4-line ri-spin"></i> {{ 'fetchingAttendanceFor' | translate }} {{ calendarMonthLabel }}...
          </div>

          <div class="ssd-cal-weekday-row">
            <span>{{ 'weekdaySu' | translate }}</span><span>{{ 'weekdayMo' | translate }}</span><span>{{ 'weekdayTu' | translate }}</span><span>{{ 'weekdayWe' | translate }}</span><span>{{ 'weekdayTh' | translate }}</span><span>{{ 'weekdayFr' | translate }}</span><span>{{ 'weekdaySa' | translate }}</span>
          </div>
          <div class="ssd-cal-week-row" *ngFor="let week of calendarWeeks">
            <div class="ssd-cal-day" *ngFor="let day of week"
                 [ngClass]="dayTileClass(day)"
                 [class.ssd-cal-day-tappable]="isDayTappable(day)"
                 [class.ssd-cal-day-selected]="selectedDay && selectedDay.date.getTime() === day.date.getTime()"
                 (click)="selectDay(day)">
              {{ day.dayOfMonth }}
            </div>
          </div>

          <div class="ssd-cal-legend">
            <span><span class="ssd-cal-swatch ssd-cal-day-present"></span> {{ 'present' | translate }}</span>
            <span><span class="ssd-cal-swatch ssd-cal-day-absent"></span> {{ 'absent' | translate }}</span>
            <span><span class="ssd-cal-swatch ssd-cal-day-late"></span> {{ 'lateStatus' | translate }}</span>
            <span><span class="ssd-cal-swatch ssd-cal-day-partial"></span> {{ 'partialStatus' | translate }}</span>
            <span><span class="ssd-cal-swatch ssd-cal-day-leave"></span> {{ 'leave' | translate }}</span>
            <span><span class="ssd-cal-swatch ssd-cal-day-none"></span> {{ 'noDataShort' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="st-card" *ngIf="selectedDay">
        <h3 class="st-card-title">{{ 'partialAttendance' | translate }}</h3>
        <div class="st-empty-state" *ngIf="partialLoading">
          <i class="ri-loader-4-line ri-spin"></i> {{ 'loadingPeriods' | translate }}
        </div>
        <div class="ssd-period-card" *ngFor="let p of partialPeriods">
          <div class="ssd-period-row">
            <div class="st-list-text">
              <div class="st-list-title">{{ p.subject || ('notAvailableGeneric' | translate) }}</div>
              <div class="st-list-sub" *ngIf="p.periodStart && p.periodEnd">{{ formatPeriodTime(p.periodStart) }} - {{ formatPeriodTime(p.periodEnd) }}</div>
              <div class="st-list-sub" *ngIf="!p.periodStart || !p.periodEnd">{{ 'wholeDay' | translate }}</div>
            </div>
            <span class="st-chip" [ngClass]="periodStatusChipClass(p.Attendance)">{{ p.Attendance }}</span>
          </div>
          <div class="ssd-period-teacher">
            <div class="st-avatar">
              <img *ngIf="p.staffImage" [src]="p.staffImage" alt="" />
            </div>
            <span class="st-list-sub">{{ p.staffName || ('notAvailableGeneric' | translate) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Documents -->
    <div *ngIf="activeTab === 'documents'">
      <div class="ssd-doc-search">
        <i class="ri-search-line"></i>
        <input type="text" placeholder="{{ 'searchDocuments' | translate }}" [(ngModel)]="documentSearchQuery" (ngModelChange)="onDocumentSearchChange()" />
      </div>

      <div class="st-card">
        <ng-container *ngIf="documentsLoading">
          <div class="ssd-doc-row ssd-doc-skeleton-row" *ngFor="let _ of [1,2,3,4,5,6,7,8]">
            <div class="ssd-doc-skeleton ssd-doc-skeleton-icon"></div>
            <div class="st-list-text">
              <div class="ssd-doc-skeleton ssd-doc-skeleton-line ssd-doc-skeleton-line-title"></div>
              <div class="ssd-doc-skeleton ssd-doc-skeleton-line ssd-doc-skeleton-line-sub"></div>
            </div>
          </div>
        </ng-container>

        <div class="st-empty-state" *ngIf="!documentsLoading && documentsLoadError">
          <i class="ri-error-warning-line"></i> {{ 'couldntLoadDocumentsPleaseTryAgain' | translate }}
        </div>

        <div class="st-empty-state" *ngIf="!documentsLoading && !documentsLoadError && documentsLoaded && documents.length === 0">
          <i class="ri-file-text-line"></i> {{ 'noDocuments' | translate }}
        </div>

        <div class="ssd-doc-row" *ngFor="let doc of documents" (click)="openDocument(doc)">
          <div class="ssd-doc-icon"><i [ngClass]="documentIcon(doc)"></i></div>
          <div class="st-list-text">
            <div class="st-list-title">{{ doc.documentTitle }}</div>
            <div class="st-list-sub">{{ doc.documentDescription || ('descriptionNotAvailable' | translate) }}</div>
          </div>
          <div class="st-list-sub ssd-doc-date">{{ doc.createdOn }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Document preview overlay (PDF / image) -->
<div class="ssd-doc-overlay" *ngIf="showDocumentPreview" (click)="closeDocumentPreview()">
  <button class="ssd-doc-overlay-btn ssd-doc-close-btn" (click)="closeDocumentPreview()"><i class="ri-close-line"></i></button>
  <button class="ssd-doc-overlay-btn ssd-doc-download-btn" (click)="downloadDocument(previewDocument); $event.stopPropagation()" *ngIf="previewDocument">
    <i class="ri-download-line"></i>
  </button>
  <div class="ssd-doc-overlay-content" (click)="$event.stopPropagation()">
    <iframe *ngIf="previewDocument?.fileType === 'pdf'" [src]="previewSafeUrl" class="ssd-doc-overlay-frame"></iframe>
    <img *ngIf="previewDocument?.fileType === 'image'" [src]="previewDocument?.documentUrl" class="ssd-doc-overlay-image" alt="" />
  </div>
</div>
